<template>
	<div
		v-if="!dragging"
		:style="style"
		:class="extraClasses"
		class="grid-row"
		@click="$emit('click', $event)"
		@dblclick="$emit('dblclick')"
		@contextmenu="_onContextMenu"
		@mouseenter="$emit('mouseenter')"
		@mouseleave="$emit('mouseleave')"
	>
		<div v-if="checkboxVisible" class="grid-cell-select" @click.stop.prevent="$emit('checkboxClicked')">
			<slot name="selected">
				<t-checkbox
					:checked="selected"
					:disableTabbing="disableSelectCheckboxTabbing"
				/>
			</slot>
		</div>
		<template v-for="column in columns">
			<t-column
				:key="column.field"
				:item="item"
				:column="column"
				:columnDefinition="columnDefinitions[column.field]"
				:columnStyle="columnStyles[column.field]"
			>
				<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
					<slot v-if="slot !== 'contextMenu'" :name="slot" v-bind="scope" />
				</template>
			</t-column>
		</template>

		<t-popover
			ref="contextMenu"
			closeOnClick
			closeOnRightClick
			@open="contextMenuOpen = true"
			@close="contextMenuOpen = false;"
		>
			<slot name="contextMenu" :item="item"/>
		</t-popover>
	</div>
	<div v-else class="hidden-row" :style="style" />
</template>

<script>
import TPopover from '@/components/evergreen/overlays/TPopover';
import TCheckbox from '../../inputs/TCheckbox';
import TColumn from './TColumn';
export default {
	name: 'TRow',
	components: {
		TPopover,
		TColumn,
		TCheckbox
	},
	props: {
		item: Object,
		columnDefinitions: Object,
		columns: Array,
		columnStyles: Object,
		rowHeight: Number,
		selected: Boolean,
		focused: Boolean,
		checkboxVisible: Boolean,
		hovered: Boolean,
		draggable: Boolean,

		/**
		 * Disable being able to tab to checkboxes for selecting rows. Sets tabindex to -1
		 */
		disableSelectCheckboxTabbing: {
			type: Boolean,
			default: false
		},
		/**
		 * Show warning color for row
		 */
		activeRowWarning: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return { contextMenuOpen: false, };
	},
	computed: {
		style: {
			cache: false,
			get() {
				let styleString = '';
				return `${styleString}height: ${this.rowHeight}px; user-select: ${this.dragging ? 'none' : 'normal'};`;
			}
		},
		dragging() {
			return this.draggable && this.selected && this.$store.getters['draggable/isDragging'];
		},
		extraClasses() {
			let result = {};
			if (this.selected)
				result['grid-row--selected'] = true;
			else if (this.focused)
				result['grid-row--focused'] = true;

			if (this.hovered || this.contextMenuOpen)
				result['grid-row--hover'] = true;

			if (this.activeRowWarning)
				result['warning-color'] = true;
			return result;
		}
	},
	methods: {
		_onContextMenu(event) {
			this.$emit('contextmenu', { event, popover: this.$refs.contextMenu });
		}
	}
};
</script>

<style scoped>
.hidden-row {
	border: 5px solid #F5F6F7;
	background: #e4e7eb;
}

.warning-color {
	background: #ffe9d2 !important;
}
</style>


